import { inject, Injectable, InjectionToken } from '@angular/core';
import { getRuntimeConfig } from './runtime-config';

export interface Environment {
  production: boolean;
  version?: string;
}

export const ENVIRONMENT = new InjectionToken<Environment>('environment');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  environment = inject(ENVIRONMENT, { optional: true });

  get production(): boolean {
    return this.environment?.production ?? false;
  }

  get version(): string {
    return this.environment?.version ?? '';
  }
  get aiEnabled(): boolean {
    return getRuntimeConfig().features?.ai ?? false;
  }

  get enableGoogle(): boolean {
    return getRuntimeConfig().features?.google ?? false;
  }
  getEnvironment(): Environment {
    return this.environment ?? { production: false };
  }
  getTopBarIdentifier(): string {
    return getRuntimeConfig().ui?.topBarIdentifier ?? 'top-bar';
  }
}
